// source: itrdrorder.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var itrdrmsgs_common_pb = require('./itrdrmsgs_common_pb.js');
goog.object.extend(proto, itrdrmsgs_common_pb);
var fix_pb = require('./fix_pb.js');
goog.object.extend(proto, fix_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
var singlegeneralorderhandling_pb = require('./singlegeneralorderhandling_pb.js');
goog.object.extend(proto, singlegeneralorderhandling_pb);
goog.exportSymbol('proto.it_grpc.ITrdrInstrumentLegOverride', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrder', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOrderEntryMessage', null, global);
goog.exportSymbol('proto.it_grpc.ITrdrOvernightOrder', null, global);
goog.exportSymbol('proto.it_grpc.InstrumentOverride', null, global);
goog.exportSymbol('proto.it_grpc.OpenOrderStateEnum', null, global);
goog.exportSymbol('proto.it_grpc.OrderEntryDetails', null, global);
goog.exportSymbol('proto.it_grpc.OrderEntryMessageTypeEnum', null, global);
goog.exportSymbol('proto.it_grpc.OrderStateEnum', null, global);
goog.exportSymbol('proto.it_grpc.OvernightOrderStatusEnum', null, global);
goog.exportSymbol('proto.it_grpc.ParentOrderTypeEnum', null, global);
goog.exportSymbol('proto.it_grpc.finxai_order_alloc_update_msg', null, global);
goog.exportSymbol('proto.it_grpc.finxai_order_cashbook_update_msg', null, global);
goog.exportSymbol('proto.it_grpc.finxai_order_show_client_update_msg', null, global);
goog.exportSymbol('proto.it_grpc.finxai_orderoverride_msg', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.ITrdrOrder.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.ITrdrOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrder.displayName = 'proto.it_grpc.ITrdrOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.displayName = 'proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.finxai_orderoverride_msg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.finxai_orderoverride_msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.finxai_orderoverride_msg.displayName = 'proto.it_grpc.finxai_orderoverride_msg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.finxai_order_alloc_update_msg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.finxai_order_alloc_update_msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.finxai_order_alloc_update_msg.displayName = 'proto.it_grpc.finxai_order_alloc_update_msg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.finxai_order_cashbook_update_msg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.finxai_order_cashbook_update_msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.finxai_order_cashbook_update_msg.displayName = 'proto.it_grpc.finxai_order_cashbook_update_msg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.finxai_order_show_client_update_msg = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.finxai_order_show_client_update_msg, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.finxai_order_show_client_update_msg.displayName = 'proto.it_grpc.finxai_order_show_client_update_msg';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOvernightOrder = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrOvernightOrder, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOvernightOrder.displayName = 'proto.it_grpc.ITrdrOvernightOrder';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrInstrumentLegOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrInstrumentLegOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrInstrumentLegOverride.displayName = 'proto.it_grpc.ITrdrInstrumentLegOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.InstrumentOverride = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.it_grpc.InstrumentOverride.repeatedFields_, null);
};
goog.inherits(proto.it_grpc.InstrumentOverride, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.InstrumentOverride.displayName = 'proto.it_grpc.InstrumentOverride';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.OrderEntryDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.OrderEntryDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.OrderEntryDetails.displayName = 'proto.it_grpc.OrderEntryDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.it_grpc.ITrdrOrderEntryMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.it_grpc.ITrdrOrderEntryMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.it_grpc.ITrdrOrderEntryMessage.displayName = 'proto.it_grpc.ITrdrOrderEntryMessage';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.ITrdrOrder.repeatedFields_ = [3,4,26,33];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = msg.getUuid()) && itrdrmsgs_common_pb.ITrdrUUID.toObject(includeInstance, f),
    parentOrderId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    childOrdIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
    execIdsList: (f = jspb.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
    ordId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    externalOrdId: jspb.Message.getFieldWithDefault(msg, 6, ""),
    ordLinkId: jspb.Message.getFieldWithDefault(msg, 7, ""),
    secondaryOrdId: jspb.Message.getFieldWithDefault(msg, 8, ""),
    parentType: jspb.Message.getFieldWithDefault(msg, 9, 0),
    hasParent: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    hasChildren: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
    account: jspb.Message.getFieldWithDefault(msg, 12, ""),
    side: jspb.Message.getFieldWithDefault(msg, 13, 0),
    ordType: jspb.Message.getFieldWithDefault(msg, 14, 0),
    securityId: jspb.Message.getFieldWithDefault(msg, 15, ""),
    marketId: jspb.Message.getFieldWithDefault(msg, 16, ""),
    ordState: jspb.Message.getFieldWithDefault(msg, 17, 0),
    openOrdState: jspb.Message.getFieldWithDefault(msg, 18, 0),
    ordStatus: jspb.Message.getFieldWithDefault(msg, 19, 0),
    rejectReason: jspb.Message.getFieldWithDefault(msg, 20, 0),
    statusMessage: jspb.Message.getFieldWithDefault(msg, 21, ""),
    orderDetail: (f = msg.getOrderDetail()) && proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.toObject(includeInstance, f),
    exchange: jspb.Message.getFieldWithDefault(msg, 23, ""),
    text: jspb.Message.getFieldWithDefault(msg, 24, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 25, ""),
    partiesList: jspb.Message.toObjectList(msg.getPartiesList(),
    common_pb.Parties.toObject, includeInstance),
    stipulations: jspb.Message.getFieldWithDefault(msg, 27, ""),
    timeInForce: jspb.Message.getFieldWithDefault(msg, 28, 0),
    expireTime: (f = msg.getExpireTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    effectiveTime: (f = msg.getEffectiveTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    startTime: (f = msg.getStartTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    submitTime: (f = msg.getSubmitTime()) && fix_pb.Timestamp.toObject(includeInstance, f),
    orderRestrictionsList: (f = jspb.Message.getRepeatedField(msg, 33)) == null ? undefined : f,
    displayInstruction: (f = msg.getDisplayInstruction()) && common_pb.DisplayInstruction.toObject(includeInstance, f),
    manualOrderIndicator: jspb.Message.getBooleanFieldWithDefault(msg, 35, false),
    commissionData: (f = msg.getCommissionData()) && common_pb.CommissionData.toObject(includeInstance, f),
    orderPlacementUser: jspb.Message.getFieldWithDefault(msg, 37, ""),
    orderOwnerUser: jspb.Message.getFieldWithDefault(msg, 38, ""),
    exchangeUserId: jspb.Message.getFieldWithDefault(msg, 39, ""),
    allocationId: jspb.Message.getFieldWithDefault(msg, 40, ""),
    isAllocated: jspb.Message.getBooleanFieldWithDefault(msg, 41, false),
    sentToTpos: jspb.Message.getBooleanFieldWithDefault(msg, 42, false),
    showClient: jspb.Message.getBooleanFieldWithDefault(msg, 43, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrder}
 */
proto.it_grpc.ITrdrOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrder;
  return proto.it_grpc.ITrdrOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrder}
 */
proto.it_grpc.ITrdrOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrUUID;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrUUID.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentOrderId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addChildOrdIds(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.addExecIds(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalOrdId(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdLinkId(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecondaryOrdId(value);
      break;
    case 9:
      var value = /** @type {!proto.it_grpc.ParentOrderTypeEnum} */ (reader.readEnum());
      msg.setParentType(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasParent(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasChildren(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 13:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 14:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (reader.readEnum());
      msg.setOrdType(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarketId(value);
      break;
    case 17:
      var value = /** @type {!proto.it_grpc.OrderStateEnum} */ (reader.readEnum());
      msg.setOrdState(value);
      break;
    case 18:
      var value = /** @type {!proto.it_grpc.OpenOrderStateEnum} */ (reader.readEnum());
      msg.setOpenOrdState(value);
      break;
    case 19:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (reader.readEnum());
      msg.setOrdStatus(value);
      break;
    case 20:
      var value = /** @type {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} */ (reader.readEnum());
      msg.setRejectReason(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusMessage(value);
      break;
    case 22:
      var value = new proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail;
      reader.readMessage(value,proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.deserializeBinaryFromReader);
      msg.setOrderDetail(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchange(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 26:
      var value = new common_pb.Parties;
      reader.readMessage(value,common_pb.Parties.deserializeBinaryFromReader);
      msg.addParties(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setStipulations(value);
      break;
    case 28:
      var value = /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (reader.readEnum());
      msg.setTimeInForce(value);
      break;
    case 29:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpireTime(value);
      break;
    case 30:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEffectiveTime(value);
      break;
    case 31:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 32:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSubmitTime(value);
      break;
    case 33:
      var values = /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addOrderRestrictions(values[i]);
      }
      break;
    case 34:
      var value = new common_pb.DisplayInstruction;
      reader.readMessage(value,common_pb.DisplayInstruction.deserializeBinaryFromReader);
      msg.setDisplayInstruction(value);
      break;
    case 35:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setManualOrderIndicator(value);
      break;
    case 36:
      var value = new common_pb.CommissionData;
      reader.readMessage(value,common_pb.CommissionData.deserializeBinaryFromReader);
      msg.setCommissionData(value);
      break;
    case 37:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderPlacementUser(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderOwnerUser(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setExchangeUserId(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocationId(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAllocated(value);
      break;
    case 42:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSentToTpos(value);
      break;
    case 43:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrUUID.serializeBinaryToWriter
    );
  }
  f = message.getParentOrderId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChildOrdIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getExecIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      4,
      f
    );
  }
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getExternalOrdId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getOrdLinkId();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSecondaryOrdId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getParentType();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getHasParent();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getHasChildren();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getOrdType();
  if (f !== 0.0) {
    writer.writeEnum(
      14,
      f
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getMarketId();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrdState();
  if (f !== 0.0) {
    writer.writeEnum(
      17,
      f
    );
  }
  f = message.getOpenOrdState();
  if (f !== 0.0) {
    writer.writeEnum(
      18,
      f
    );
  }
  f = message.getOrdStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      19,
      f
    );
  }
  f = message.getRejectReason();
  if (f !== 0.0) {
    writer.writeEnum(
      20,
      f
    );
  }
  f = message.getStatusMessage();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getOrderDetail();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.serializeBinaryToWriter
    );
  }
  f = message.getExchange();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getPartiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      26,
      f,
      common_pb.Parties.serializeBinaryToWriter
    );
  }
  f = message.getStipulations();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getTimeInForce();
  if (f !== 0.0) {
    writer.writeEnum(
      28,
      f
    );
  }
  f = message.getExpireTime();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEffectiveTime();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSubmitTime();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrderRestrictionsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      33,
      f
    );
  }
  f = message.getDisplayInstruction();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      common_pb.DisplayInstruction.serializeBinaryToWriter
    );
  }
  f = message.getManualOrderIndicator();
  if (f) {
    writer.writeBool(
      35,
      f
    );
  }
  f = message.getCommissionData();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      common_pb.CommissionData.serializeBinaryToWriter
    );
  }
  f = message.getOrderPlacementUser();
  if (f.length > 0) {
    writer.writeString(
      37,
      f
    );
  }
  f = message.getOrderOwnerUser();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getExchangeUserId();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getAllocationId();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getIsAllocated();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
  f = message.getSentToTpos();
  if (f) {
    writer.writeBool(
      42,
      f
    );
  }
  f = message.getShowClient();
  if (f) {
    writer.writeBool(
      43,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    workingPx: (f = msg.getWorkingPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    exchangePx: (f = msg.getExchangePx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    avgFillPx: (f = msg.getAvgFillPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty: (f = msg.getOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    workingQty: (f = msg.getWorkingQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    exchangeQty: (f = msg.getExchangeQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    filledQty: (f = msg.getFilledQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty2: (f = msg.getOrderQty2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    stopPx: (f = msg.getStopPx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxPriceLevels: jspb.Message.getFieldWithDefault(msg, 11, 0),
    price2: (f = msg.getPrice2()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceType: jspb.Message.getFieldWithDefault(msg, 13, 0),
    yieldData: (f = msg.getYieldData()) && common_pb.YieldData.toObject(includeInstance, f),
    prevClosePx: (f = msg.getPrevClosePx()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxFloor: (f = msg.getMaxFloor()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxShow: (f = msg.getMaxShow()) && fix_pb.Decimal64.toObject(includeInstance, f),
    minQty: (f = msg.getMinQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    qtyOverride: (f = msg.getQtyOverride()) && fix_pb.Decimal64.toObject(includeInstance, f),
    filledQtyOverride: (f = msg.getFilledQtyOverride()) && fix_pb.Decimal64.toObject(includeInstance, f),
    priceOverride: (f = msg.getPriceOverride()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail;
  return proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setWorkingPx(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setExchangePx(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setAvgFillPx(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setWorkingQty(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setExchangeQty(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFilledQty(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty2(value);
      break;
    case 10:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setStopPx(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readSfixed64());
      msg.setMaxPriceLevels(value);
      break;
    case 12:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice2(value);
      break;
    case 13:
      var value = /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (reader.readEnum());
      msg.setPriceType(value);
      break;
    case 14:
      var value = new common_pb.YieldData;
      reader.readMessage(value,common_pb.YieldData.deserializeBinaryFromReader);
      msg.setYieldData(value);
      break;
    case 15:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrevClosePx(value);
      break;
    case 16:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxFloor(value);
      break;
    case 17:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxShow(value);
      break;
    case 18:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMinQty(value);
      break;
    case 19:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setQtyOverride(value);
      break;
    case 20:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFilledQtyOverride(value);
      break;
    case 21:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPriceOverride(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getWorkingPx();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getExchangePx();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getAvgFillPx();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getWorkingQty();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getExchangeQty();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFilledQty();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty2();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getStopPx();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxPriceLevels();
  if (f !== 0) {
    writer.writeSfixed64(
      11,
      f
    );
  }
  f = message.getPrice2();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceType();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getYieldData();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      common_pb.YieldData.serializeBinaryToWriter
    );
  }
  f = message.getPrevClosePx();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxFloor();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxShow();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMinQty();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getQtyOverride();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFilledQtyOverride();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPriceOverride();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional fix.Decimal64 price = 1;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 1));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional fix.Decimal64 working_px = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getWorkingPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setWorkingPx = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearWorkingPx = function() {
  return this.setWorkingPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasWorkingPx = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 exchange_px = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getExchangePx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setExchangePx = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearExchangePx = function() {
  return this.setExchangePx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasExchangePx = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Decimal64 avg_fill_px = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getAvgFillPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setAvgFillPx = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearAvgFillPx = function() {
  return this.setAvgFillPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasAvgFillPx = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional fix.Decimal64 order_qty = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearOrderQty = function() {
  return this.setOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasOrderQty = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 working_qty = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getWorkingQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setWorkingQty = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearWorkingQty = function() {
  return this.setWorkingQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasWorkingQty = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fix.Decimal64 exchange_qty = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getExchangeQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setExchangeQty = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearExchangeQty = function() {
  return this.setExchangeQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasExchangeQty = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fix.Decimal64 filled_qty = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getFilledQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setFilledQty = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearFilledQty = function() {
  return this.setFilledQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasFilledQty = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional fix.Decimal64 order_qty2 = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getOrderQty2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setOrderQty2 = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearOrderQty2 = function() {
  return this.setOrderQty2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasOrderQty2 = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fix.Decimal64 stop_px = 10;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getStopPx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 10));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setStopPx = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearStopPx = function() {
  return this.setStopPx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasStopPx = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional sfixed64 max_price_levels = 11;
 * @return {number}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getMaxPriceLevels = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setMaxPriceLevels = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional fix.Decimal64 price2 = 12;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getPrice2 = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 12));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setPrice2 = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearPrice2 = function() {
  return this.setPrice2(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasPrice2 = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional SingleGeneralOrderHandling.PriceTypeEnum price_type = 13;
 * @return {!proto.SingleGeneralOrderHandling.PriceTypeEnum}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getPriceType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.PriceTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.PriceTypeEnum} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setPriceType = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional Common.YieldData yield_data = 14;
 * @return {?proto.Common.YieldData}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getYieldData = function() {
  return /** @type{?proto.Common.YieldData} */ (
    jspb.Message.getWrapperField(this, common_pb.YieldData, 14));
};


/**
 * @param {?proto.Common.YieldData|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setYieldData = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearYieldData = function() {
  return this.setYieldData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasYieldData = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional fix.Decimal64 prev_close_px = 15;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getPrevClosePx = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 15));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setPrevClosePx = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearPrevClosePx = function() {
  return this.setPrevClosePx(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasPrevClosePx = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional fix.Decimal64 max_floor = 16;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getMaxFloor = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 16));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setMaxFloor = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearMaxFloor = function() {
  return this.setMaxFloor(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasMaxFloor = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional fix.Decimal64 max_show = 17;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getMaxShow = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 17));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setMaxShow = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearMaxShow = function() {
  return this.setMaxShow(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasMaxShow = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional fix.Decimal64 min_qty = 18;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getMinQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 18));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setMinQty = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearMinQty = function() {
  return this.setMinQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasMinQty = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional fix.Decimal64 qty_override = 19;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getQtyOverride = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 19));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setQtyOverride = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearQtyOverride = function() {
  return this.setQtyOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasQtyOverride = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional fix.Decimal64 filled_qty_override = 20;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getFilledQtyOverride = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 20));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setFilledQtyOverride = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearFilledQtyOverride = function() {
  return this.setFilledQtyOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasFilledQtyOverride = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional fix.Decimal64 price_override = 21;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.getPriceOverride = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 21));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
*/
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.setPriceOverride = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} returns this
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.clearPriceOverride = function() {
  return this.setPriceOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail.prototype.hasPriceOverride = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional ITrdrUUID uuid = 1;
 * @return {?proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.ITrdrOrder.prototype.getUuid = function() {
  return /** @type{?proto.it_grpc.ITrdrUUID} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrUUID, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrUUID|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string parent_order_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getParentOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setParentOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string child_ord_ids = 3;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrOrder.prototype.getChildOrdIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setChildOrdIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.addChildOrdIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearChildOrdIdsList = function() {
  return this.setChildOrdIdsList([]);
};


/**
 * repeated string exec_ids = 4;
 * @return {!Array<string>}
 */
proto.it_grpc.ITrdrOrder.prototype.getExecIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 4));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setExecIdsList = function(value) {
  return jspb.Message.setField(this, 4, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.addExecIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 4, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearExecIdsList = function() {
  return this.setExecIdsList([]);
};


/**
 * optional string ord_id = 5;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string external_ord_id = 6;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getExternalOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setExternalOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string ord_link_id = 7;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrdLinkId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrdLinkId = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string secondary_ord_id = 8;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getSecondaryOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setSecondaryOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional ParentOrderTypeEnum parent_type = 9;
 * @return {!proto.it_grpc.ParentOrderTypeEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getParentType = function() {
  return /** @type {!proto.it_grpc.ParentOrderTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.it_grpc.ParentOrderTypeEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setParentType = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional bool has_parent = 10;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getHasParent = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setHasParent = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional bool has_children = 11;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getHasChildren = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setHasChildren = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional string account = 12;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional SingleGeneralOrderHandling.SideEnum side = 13;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional SingleGeneralOrderHandling.OrdTypeEnum ord_type = 14;
 * @return {!proto.SingleGeneralOrderHandling.OrdTypeEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrdType = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdTypeEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrdType = function(value) {
  return jspb.Message.setProto3EnumField(this, 14, value);
};


/**
 * optional string security_id = 15;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string market_id = 16;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getMarketId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setMarketId = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional OrderStateEnum ord_state = 17;
 * @return {!proto.it_grpc.OrderStateEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrdState = function() {
  return /** @type {!proto.it_grpc.OrderStateEnum} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {!proto.it_grpc.OrderStateEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrdState = function(value) {
  return jspb.Message.setProto3EnumField(this, 17, value);
};


/**
 * optional OpenOrderStateEnum open_ord_state = 18;
 * @return {!proto.it_grpc.OpenOrderStateEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getOpenOrdState = function() {
  return /** @type {!proto.it_grpc.OpenOrderStateEnum} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {!proto.it_grpc.OpenOrderStateEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOpenOrdState = function(value) {
  return jspb.Message.setProto3EnumField(this, 18, value);
};


/**
 * optional SingleGeneralOrderHandling.OrdStatusEnum ord_status = 19;
 * @return {!proto.SingleGeneralOrderHandling.OrdStatusEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrdStatus = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdStatusEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrdStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 19, value);
};


/**
 * optional SingleGeneralOrderHandling.OrdRejReasonEnum reject_reason = 20;
 * @return {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getRejectReason = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrdRejReasonEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setRejectReason = function(value) {
  return jspb.Message.setProto3EnumField(this, 20, value);
};


/**
 * optional string status_message = 21;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getStatusMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setStatusMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional ITOrderWorkingDetail order_detail = 22;
 * @return {?proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrderDetail = function() {
  return /** @type{?proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail, 22));
};


/**
 * @param {?proto.it_grpc.ITrdrOrder.ITOrderWorkingDetail|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setOrderDetail = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearOrderDetail = function() {
  return this.setOrderDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasOrderDetail = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional string exchange = 23;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getExchange = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setExchange = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string text = 24;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};


/**
 * optional string currency = 25;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * repeated Common.Parties parties = 26;
 * @return {!Array<!proto.Common.Parties>}
 */
proto.it_grpc.ITrdrOrder.prototype.getPartiesList = function() {
  return /** @type{!Array<!proto.Common.Parties>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Parties, 26));
};


/**
 * @param {!Array<!proto.Common.Parties>} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setPartiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 26, value);
};


/**
 * @param {!proto.Common.Parties=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Common.Parties}
 */
proto.it_grpc.ITrdrOrder.prototype.addParties = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.Common.Parties, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearPartiesList = function() {
  return this.setPartiesList([]);
};


/**
 * optional string stipulations = 27;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getStipulations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setStipulations = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional SingleGeneralOrderHandling.TimeInForceEnum time_in_force = 28;
 * @return {!proto.SingleGeneralOrderHandling.TimeInForceEnum}
 */
proto.it_grpc.ITrdrOrder.prototype.getTimeInForce = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.TimeInForceEnum} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.TimeInForceEnum} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setTimeInForce = function(value) {
  return jspb.Message.setProto3EnumField(this, 28, value);
};


/**
 * optional fix.Timestamp expire_time = 29;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrOrder.prototype.getExpireTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 29));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setExpireTime = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearExpireTime = function() {
  return this.setExpireTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasExpireTime = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional fix.Timestamp effective_time = 30;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrOrder.prototype.getEffectiveTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 30));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setEffectiveTime = function(value) {
  return jspb.Message.setWrapperField(this, 30, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearEffectiveTime = function() {
  return this.setEffectiveTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasEffectiveTime = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional fix.Timestamp start_time = 31;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrOrder.prototype.getStartTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 31));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional fix.Timestamp submit_time = 32;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrOrder.prototype.getSubmitTime = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 32));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setSubmitTime = function(value) {
  return jspb.Message.setWrapperField(this, 32, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearSubmitTime = function() {
  return this.setSubmitTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasSubmitTime = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * repeated SingleGeneralOrderHandling.OrderRestrictionsEnum order_restrictions = 33;
 * @return {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrderRestrictionsList = function() {
  return /** @type {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} */ (jspb.Message.getRepeatedField(this, 33));
};


/**
 * @param {!Array<!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum>} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrderRestrictionsList = function(value) {
  return jspb.Message.setField(this, 33, value || []);
};


/**
 * @param {!proto.SingleGeneralOrderHandling.OrderRestrictionsEnum} value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.addOrderRestrictions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 33, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearOrderRestrictionsList = function() {
  return this.setOrderRestrictionsList([]);
};


/**
 * optional Common.DisplayInstruction display_instruction = 34;
 * @return {?proto.Common.DisplayInstruction}
 */
proto.it_grpc.ITrdrOrder.prototype.getDisplayInstruction = function() {
  return /** @type{?proto.Common.DisplayInstruction} */ (
    jspb.Message.getWrapperField(this, common_pb.DisplayInstruction, 34));
};


/**
 * @param {?proto.Common.DisplayInstruction|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setDisplayInstruction = function(value) {
  return jspb.Message.setWrapperField(this, 34, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearDisplayInstruction = function() {
  return this.setDisplayInstruction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasDisplayInstruction = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional bool manual_order_indicator = 35;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getManualOrderIndicator = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 35, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setManualOrderIndicator = function(value) {
  return jspb.Message.setProto3BooleanField(this, 35, value);
};


/**
 * optional Common.CommissionData commission_data = 36;
 * @return {?proto.Common.CommissionData}
 */
proto.it_grpc.ITrdrOrder.prototype.getCommissionData = function() {
  return /** @type{?proto.Common.CommissionData} */ (
    jspb.Message.getWrapperField(this, common_pb.CommissionData, 36));
};


/**
 * @param {?proto.Common.CommissionData|undefined} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
*/
proto.it_grpc.ITrdrOrder.prototype.setCommissionData = function(value) {
  return jspb.Message.setWrapperField(this, 36, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.clearCommissionData = function() {
  return this.setCommissionData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.hasCommissionData = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional string order_placement_user = 37;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrderPlacementUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 37, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrderPlacementUser = function(value) {
  return jspb.Message.setProto3StringField(this, 37, value);
};


/**
 * optional string order_owner_user = 38;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getOrderOwnerUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setOrderOwnerUser = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string exchange_user_id = 39;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getExchangeUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setExchangeUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string allocation_id = 40;
 * @return {string}
 */
proto.it_grpc.ITrdrOrder.prototype.getAllocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setAllocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional bool is_allocated = 41;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getIsAllocated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setIsAllocated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};


/**
 * optional bool sent_to_tpos = 42;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getSentToTpos = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 42, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setSentToTpos = function(value) {
  return jspb.Message.setProto3BooleanField(this, 42, value);
};


/**
 * optional bool show_client = 43;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrder.prototype.getShowClient = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 43, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOrder} returns this
 */
proto.it_grpc.ITrdrOrder.prototype.setShowClient = function(value) {
  return jspb.Message.setProto3BooleanField(this, 43, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.finxai_orderoverride_msg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.finxai_orderoverride_msg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_orderoverride_msg.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    qty: (f = msg.getQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    filledQty: (f = msg.getFilledQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.finxai_orderoverride_msg}
 */
proto.it_grpc.finxai_orderoverride_msg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.finxai_orderoverride_msg;
  return proto.it_grpc.finxai_orderoverride_msg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.finxai_orderoverride_msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.finxai_orderoverride_msg}
 */
proto.it_grpc.finxai_orderoverride_msg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 2:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setQty(value);
      break;
    case 3:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setFilledQty(value);
      break;
    case 4:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.finxai_orderoverride_msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.finxai_orderoverride_msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_orderoverride_msg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getQty();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getFilledQty();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
};


/**
 * optional string ord_id = 1;
 * @return {string}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional fix.Decimal64 qty = 2;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.getQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 2));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
*/
proto.it_grpc.finxai_orderoverride_msg.prototype.setQty = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.clearQty = function() {
  return this.setQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.hasQty = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional fix.Decimal64 filled_qty = 3;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.getFilledQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 3));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
*/
proto.it_grpc.finxai_orderoverride_msg.prototype.setFilledQty = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.clearFilledQty = function() {
  return this.setFilledQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.hasFilledQty = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional fix.Decimal64 price = 4;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 4));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
*/
proto.it_grpc.finxai_orderoverride_msg.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.finxai_orderoverride_msg} returns this
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.finxai_orderoverride_msg.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.finxai_order_alloc_update_msg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.finxai_order_alloc_update_msg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_alloc_update_msg.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    allocationId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isAllocated: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.finxai_order_alloc_update_msg}
 */
proto.it_grpc.finxai_order_alloc_update_msg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.finxai_order_alloc_update_msg;
  return proto.it_grpc.finxai_order_alloc_update_msg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.finxai_order_alloc_update_msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.finxai_order_alloc_update_msg}
 */
proto.it_grpc.finxai_order_alloc_update_msg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAllocationId(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsAllocated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.finxai_order_alloc_update_msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.finxai_order_alloc_update_msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_alloc_update_msg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAllocationId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsAllocated();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string ord_id = 1;
 * @return {string}
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.finxai_order_alloc_update_msg} returns this
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string allocation_id = 2;
 * @return {string}
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.getAllocationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.finxai_order_alloc_update_msg} returns this
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.setAllocationId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_allocated = 3;
 * @return {boolean}
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.getIsAllocated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.finxai_order_alloc_update_msg} returns this
 */
proto.it_grpc.finxai_order_alloc_update_msg.prototype.setIsAllocated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.finxai_order_cashbook_update_msg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.finxai_order_cashbook_update_msg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_cashbook_update_msg.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    sentToTpos: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.finxai_order_cashbook_update_msg}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.finxai_order_cashbook_update_msg;
  return proto.it_grpc.finxai_order_cashbook_update_msg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.finxai_order_cashbook_update_msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.finxai_order_cashbook_update_msg}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSentToTpos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.finxai_order_cashbook_update_msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.finxai_order_cashbook_update_msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_cashbook_update_msg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSentToTpos();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string ord_id = 1;
 * @return {string}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.finxai_order_cashbook_update_msg} returns this
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool sent_to_tpos = 2;
 * @return {boolean}
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.getSentToTpos = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.finxai_order_cashbook_update_msg} returns this
 */
proto.it_grpc.finxai_order_cashbook_update_msg.prototype.setSentToTpos = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.finxai_order_show_client_update_msg.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.finxai_order_show_client_update_msg} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_show_client_update_msg.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    showClient: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.finxai_order_show_client_update_msg}
 */
proto.it_grpc.finxai_order_show_client_update_msg.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.finxai_order_show_client_update_msg;
  return proto.it_grpc.finxai_order_show_client_update_msg.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.finxai_order_show_client_update_msg} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.finxai_order_show_client_update_msg}
 */
proto.it_grpc.finxai_order_show_client_update_msg.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.finxai_order_show_client_update_msg.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.finxai_order_show_client_update_msg} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.finxai_order_show_client_update_msg.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getShowClient();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string ord_id = 1;
 * @return {string}
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.finxai_order_show_client_update_msg} returns this
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool show_client = 2;
 * @return {boolean}
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.getShowClient = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.finxai_order_show_client_update_msg} returns this
 */
proto.it_grpc.finxai_order_show_client_update_msg.prototype.setShowClient = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOvernightOrder.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOvernightOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrder.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = msg.getUuid()) && itrdrmsgs_common_pb.ITrdrUUID.toObject(includeInstance, f),
    ordId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    account: jspb.Message.getFieldWithDefault(msg, 3, ""),
    text: jspb.Message.getFieldWithDefault(msg, 4, ""),
    securityId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    oldPrice: (f = msg.getOldPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    carry: (f = msg.getCarry()) && fix_pb.Decimal64.toObject(includeInstance, f),
    newPrice: (f = msg.getNewPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    orderQty: (f = msg.getOrderQty()) && fix_pb.Decimal64.toObject(includeInstance, f),
    side: jspb.Message.getFieldWithDefault(msg, 10, 0),
    ordStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    stipulations: jspb.Message.getFieldWithDefault(msg, 12, ""),
    creationDate: jspb.Message.getFieldWithDefault(msg, 13, 0),
    releaseDate: jspb.Message.getFieldWithDefault(msg, 14, 0),
    lastUpdTimestamp: (f = msg.getLastUpdTimestamp()) && fix_pb.Timestamp.toObject(includeInstance, f),
    lastUpdUser: jspb.Message.getFieldWithDefault(msg, 16, ""),
    orderError: jspb.Message.getBooleanFieldWithDefault(msg, 17, false),
    messages: jspb.Message.getFieldWithDefault(msg, 18, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOvernightOrder}
 */
proto.it_grpc.ITrdrOvernightOrder.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOvernightOrder;
  return proto.it_grpc.ITrdrOvernightOrder.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOvernightOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOvernightOrder}
 */
proto.it_grpc.ITrdrOvernightOrder.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrUUID;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrUUID.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setText(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOldPrice(value);
      break;
    case 7:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setCarry(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setNewPrice(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setOrderQty(value);
      break;
    case 10:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 11:
      var value = /** @type {!proto.it_grpc.OvernightOrderStatusEnum} */ (reader.readEnum());
      msg.setOrdStatus(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setStipulations(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setCreationDate(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setReleaseDate(value);
      break;
    case 15:
      var value = new fix_pb.Timestamp;
      reader.readMessage(value,fix_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastUpdTimestamp(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastUpdUser(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOrderError(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOvernightOrder.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOvernightOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOvernightOrder.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrUUID.serializeBinaryToWriter
    );
  }
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getOldPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getCarry();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getNewPrice();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getOrderQty();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      10,
      f
    );
  }
  f = message.getOrdStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getStipulations();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCreationDate();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
  f = message.getReleaseDate();
  if (f !== 0) {
    writer.writeSfixed32(
      14,
      f
    );
  }
  f = message.getLastUpdTimestamp();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      fix_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLastUpdUser();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getOrderError();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
  f = message.getMessages();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
};


/**
 * optional ITrdrUUID uuid = 1;
 * @return {?proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getUuid = function() {
  return /** @type{?proto.it_grpc.ITrdrUUID} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrUUID, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrUUID|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string ord_id = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getAccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setAccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string text = 4;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string security_id = 5;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional fix.Decimal64 old_price = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getOldPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setOldPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearOldPrice = function() {
  return this.setOldPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasOldPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional fix.Decimal64 carry = 7;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getCarry = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 7));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setCarry = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearCarry = function() {
  return this.setCarry(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasCarry = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional fix.Decimal64 new_price = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getNewPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setNewPrice = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearNewPrice = function() {
  return this.setNewPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasNewPrice = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional fix.Decimal64 order_qty = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getOrderQty = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setOrderQty = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearOrderQty = function() {
  return this.setOrderQty(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasOrderQty = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional SingleGeneralOrderHandling.SideEnum side = 10;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 10, value);
};


/**
 * optional OvernightOrderStatusEnum ord_status = 11;
 * @return {!proto.it_grpc.OvernightOrderStatusEnum}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getOrdStatus = function() {
  return /** @type {!proto.it_grpc.OvernightOrderStatusEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.it_grpc.OvernightOrderStatusEnum} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setOrdStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional string stipulations = 12;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getStipulations = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setStipulations = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional sfixed32 creation_date = 13;
 * @return {number}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getCreationDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setCreationDate = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional sfixed32 release_date = 14;
 * @return {number}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getReleaseDate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setReleaseDate = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional fix.Timestamp last_upd_timestamp = 15;
 * @return {?proto.fix.Timestamp}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getLastUpdTimestamp = function() {
  return /** @type{?proto.fix.Timestamp} */ (
    jspb.Message.getWrapperField(this, fix_pb.Timestamp, 15));
};


/**
 * @param {?proto.fix.Timestamp|undefined} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
*/
proto.it_grpc.ITrdrOvernightOrder.prototype.setLastUpdTimestamp = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.clearLastUpdTimestamp = function() {
  return this.setLastUpdTimestamp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.hasLastUpdTimestamp = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string last_upd_user = 16;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getLastUpdUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setLastUpdUser = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional bool order_error = 17;
 * @return {boolean}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getOrderError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setOrderError = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};


/**
 * optional string messages = 18;
 * @return {string}
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.getMessages = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOvernightOrder} returns this
 */
proto.it_grpc.ITrdrOvernightOrder.prototype.setMessages = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrInstrumentLegOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrInstrumentLegOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentLegOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
    legId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    tickerSymbol: jspb.Message.getFieldWithDefault(msg, 2, ""),
    isInitiate: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    isShowLeg: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    payup: jspb.Message.getFieldWithDefault(msg, 5, 0),
    edgeVolume: jspb.Message.getFieldWithDefault(msg, 6, 0),
    edgeRatioPc: jspb.Message.getFieldWithDefault(msg, 7, 0),
    risk: (f = msg.getRisk()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxexposedsz: (f = msg.getMaxexposedsz()) && fix_pb.Decimal64.toObject(includeInstance, f),
    maxexposededgesz: (f = msg.getMaxexposededgesz()) && fix_pb.Decimal64.toObject(includeInstance, f),
    missedlegStrategy: jspb.Message.getFieldWithDefault(msg, 11, ""),
    restingInside: jspb.Message.getFieldWithDefault(msg, 12, 0),
    restingOutside: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrInstrumentLegOverride;
  return proto.it_grpc.ITrdrInstrumentLegOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrInstrumentLegOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setLegId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTickerSymbol(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInitiate(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsShowLeg(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setPayup(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEdgeVolume(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEdgeRatioPc(value);
      break;
    case 8:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setRisk(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxexposedsz(value);
      break;
    case 10:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setMaxexposededgesz(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setMissedlegStrategy(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setRestingInside(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setRestingOutside(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrInstrumentLegOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrInstrumentLegOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrInstrumentLegOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLegId();
  if (f !== 0) {
    writer.writeSfixed32(
      1,
      f
    );
  }
  f = message.getTickerSymbol();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIsInitiate();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getIsShowLeg();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getPayup();
  if (f !== 0) {
    writer.writeSfixed32(
      5,
      f
    );
  }
  f = message.getEdgeVolume();
  if (f !== 0) {
    writer.writeSfixed32(
      6,
      f
    );
  }
  f = message.getEdgeRatioPc();
  if (f !== 0) {
    writer.writeSfixed32(
      7,
      f
    );
  }
  f = message.getRisk();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxexposedsz();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMaxexposededgesz();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getMissedlegStrategy();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getRestingInside();
  if (f !== 0) {
    writer.writeSfixed32(
      12,
      f
    );
  }
  f = message.getRestingOutside();
  if (f !== 0) {
    writer.writeSfixed32(
      13,
      f
    );
  }
};


/**
 * optional sfixed32 leg_id = 1;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getLegId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setLegId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string ticker_symbol = 2;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getTickerSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setTickerSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool is_initiate = 3;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getIsInitiate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setIsInitiate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool is_show_leg = 4;
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getIsShowLeg = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setIsShowLeg = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional sfixed32 payup = 5;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getPayup = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setPayup = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sfixed32 edge_volume = 6;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getEdgeVolume = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setEdgeVolume = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional sfixed32 edge_ratio_pc = 7;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getEdgeRatioPc = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setEdgeRatioPc = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional fix.Decimal64 risk = 8;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getRisk = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 8));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
*/
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setRisk = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.clearRisk = function() {
  return this.setRisk(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.hasRisk = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional fix.Decimal64 maxexposedsz = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getMaxexposedsz = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
*/
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setMaxexposedsz = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.clearMaxexposedsz = function() {
  return this.setMaxexposedsz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.hasMaxexposedsz = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional fix.Decimal64 maxexposedEDGEsz = 10;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getMaxexposededgesz = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 10));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
*/
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setMaxexposededgesz = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.clearMaxexposededgesz = function() {
  return this.setMaxexposededgesz(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.hasMaxexposededgesz = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string missedleg_strategy = 11;
 * @return {string}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getMissedlegStrategy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setMissedlegStrategy = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional sfixed32 resting_inside = 12;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getRestingInside = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setRestingInside = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional sfixed32 resting_outside = 13;
 * @return {number}
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.getRestingOutside = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride} returns this
 */
proto.it_grpc.ITrdrInstrumentLegOverride.prototype.setRestingOutside = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.it_grpc.InstrumentOverride.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.InstrumentOverride.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.InstrumentOverride.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.InstrumentOverride} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentOverride.toObject = function(includeInstance, msg) {
  var f, obj = {
    uuid: (f = msg.getUuid()) && itrdrmsgs_common_pb.ITrdrUUID.toObject(includeInstance, f),
    securityId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    symbol: jspb.Message.getFieldWithDefault(msg, 3, ""),
    source: jspb.Message.getFieldWithDefault(msg, 4, ""),
    maxshow: jspb.Message.getFieldWithDefault(msg, 5, 0),
    minshow: jspb.Message.getFieldWithDefault(msg, 6, 0),
    maxExposure: jspb.Message.getFieldWithDefault(msg, 7, 0),
    maxMisses: jspb.Message.getFieldWithDefault(msg, 8, 0),
    priceIncrement: (f = msg.getPriceIncrement()) && fix_pb.Decimal64.toObject(includeInstance, f),
    edgeExposure: jspb.Message.getFieldWithDefault(msg, 10, 0),
    subaccount: jspb.Message.getFieldWithDefault(msg, 11, ""),
    legsInfoList: jspb.Message.toObjectList(msg.getLegsInfoList(),
    proto.it_grpc.ITrdrInstrumentLegOverride.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.InstrumentOverride}
 */
proto.it_grpc.InstrumentOverride.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.InstrumentOverride;
  return proto.it_grpc.InstrumentOverride.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.InstrumentOverride} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.InstrumentOverride}
 */
proto.it_grpc.InstrumentOverride.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new itrdrmsgs_common_pb.ITrdrUUID;
      reader.readMessage(value,itrdrmsgs_common_pb.ITrdrUUID.deserializeBinaryFromReader);
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSymbol(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaxshow(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMinshow(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaxExposure(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setMaxMisses(value);
      break;
    case 9:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPriceIncrement(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readSfixed32());
      msg.setEdgeExposure(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubaccount(value);
      break;
    case 12:
      var value = new proto.it_grpc.ITrdrInstrumentLegOverride;
      reader.readMessage(value,proto.it_grpc.ITrdrInstrumentLegOverride.deserializeBinaryFromReader);
      msg.addLegsInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.InstrumentOverride.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.InstrumentOverride.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.InstrumentOverride} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.InstrumentOverride.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      itrdrmsgs_common_pb.ITrdrUUID.serializeBinaryToWriter
    );
  }
  f = message.getSecurityId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSymbol();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMaxshow();
  if (f !== 0) {
    writer.writeSfixed32(
      5,
      f
    );
  }
  f = message.getMinshow();
  if (f !== 0) {
    writer.writeSfixed32(
      6,
      f
    );
  }
  f = message.getMaxExposure();
  if (f !== 0) {
    writer.writeSfixed32(
      7,
      f
    );
  }
  f = message.getMaxMisses();
  if (f !== 0) {
    writer.writeSfixed32(
      8,
      f
    );
  }
  f = message.getPriceIncrement();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getEdgeExposure();
  if (f !== 0) {
    writer.writeSfixed32(
      10,
      f
    );
  }
  f = message.getSubaccount();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getLegsInfoList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      proto.it_grpc.ITrdrInstrumentLegOverride.serializeBinaryToWriter
    );
  }
};


/**
 * optional ITrdrUUID uuid = 1;
 * @return {?proto.it_grpc.ITrdrUUID}
 */
proto.it_grpc.InstrumentOverride.prototype.getUuid = function() {
  return /** @type{?proto.it_grpc.ITrdrUUID} */ (
    jspb.Message.getWrapperField(this, itrdrmsgs_common_pb.ITrdrUUID, 1));
};


/**
 * @param {?proto.it_grpc.ITrdrUUID|undefined} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
*/
proto.it_grpc.InstrumentOverride.prototype.setUuid = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.clearUuid = function() {
  return this.setUuid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.InstrumentOverride.prototype.hasUuid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string security_id = 2;
 * @return {string}
 */
proto.it_grpc.InstrumentOverride.prototype.getSecurityId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setSecurityId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string symbol = 3;
 * @return {string}
 */
proto.it_grpc.InstrumentOverride.prototype.getSymbol = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setSymbol = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string source = 4;
 * @return {string}
 */
proto.it_grpc.InstrumentOverride.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional sfixed32 maxshow = 5;
 * @return {number}
 */
proto.it_grpc.InstrumentOverride.prototype.getMaxshow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setMaxshow = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional sfixed32 minshow = 6;
 * @return {number}
 */
proto.it_grpc.InstrumentOverride.prototype.getMinshow = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setMinshow = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional sfixed32 max_exposure = 7;
 * @return {number}
 */
proto.it_grpc.InstrumentOverride.prototype.getMaxExposure = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setMaxExposure = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional sfixed32 max_misses = 8;
 * @return {number}
 */
proto.it_grpc.InstrumentOverride.prototype.getMaxMisses = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setMaxMisses = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional fix.Decimal64 price_increment = 9;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.InstrumentOverride.prototype.getPriceIncrement = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 9));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
*/
proto.it_grpc.InstrumentOverride.prototype.setPriceIncrement = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.clearPriceIncrement = function() {
  return this.setPriceIncrement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.InstrumentOverride.prototype.hasPriceIncrement = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional sfixed32 EDGE_exposure = 10;
 * @return {number}
 */
proto.it_grpc.InstrumentOverride.prototype.getEdgeExposure = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setEdgeExposure = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string subaccount = 11;
 * @return {string}
 */
proto.it_grpc.InstrumentOverride.prototype.getSubaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.setSubaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated ITrdrInstrumentLegOverride legs_info = 12;
 * @return {!Array<!proto.it_grpc.ITrdrInstrumentLegOverride>}
 */
proto.it_grpc.InstrumentOverride.prototype.getLegsInfoList = function() {
  return /** @type{!Array<!proto.it_grpc.ITrdrInstrumentLegOverride>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.it_grpc.ITrdrInstrumentLegOverride, 12));
};


/**
 * @param {!Array<!proto.it_grpc.ITrdrInstrumentLegOverride>} value
 * @return {!proto.it_grpc.InstrumentOverride} returns this
*/
proto.it_grpc.InstrumentOverride.prototype.setLegsInfoList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.it_grpc.ITrdrInstrumentLegOverride=} opt_value
 * @param {number=} opt_index
 * @return {!proto.it_grpc.ITrdrInstrumentLegOverride}
 */
proto.it_grpc.InstrumentOverride.prototype.addLegsInfo = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.it_grpc.ITrdrInstrumentLegOverride, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.it_grpc.InstrumentOverride} returns this
 */
proto.it_grpc.InstrumentOverride.prototype.clearLegsInfoList = function() {
  return this.setLegsInfoList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.OrderEntryDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.OrderEntryDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.OrderEntryDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.OrderEntryDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    comments: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subaccount: jspb.Message.getFieldWithDefault(msg, 3, ""),
    side: jspb.Message.getFieldWithDefault(msg, 4, 0),
    quantity: (f = msg.getQuantity()) && fix_pb.Decimal64.toObject(includeInstance, f),
    price: (f = msg.getPrice()) && fix_pb.Decimal64.toObject(includeInstance, f),
    submitSuspended: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    placementUser: jspb.Message.getFieldWithDefault(msg, 8, ""),
    onbehalfof: jspb.Message.getFieldWithDefault(msg, 9, ""),
    instOverride: (f = msg.getInstOverride()) && proto.it_grpc.InstrumentOverride.toObject(includeInstance, f),
    orderStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
    updInstOnly: jspb.Message.getBooleanFieldWithDefault(msg, 12, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.OrderEntryDetails}
 */
proto.it_grpc.OrderEntryDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.OrderEntryDetails;
  return proto.it_grpc.OrderEntryDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.OrderEntryDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.OrderEntryDetails}
 */
proto.it_grpc.OrderEntryDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrdId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setComments(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubaccount(value);
      break;
    case 4:
      var value = /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (reader.readEnum());
      msg.setSide(value);
      break;
    case 5:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setQuantity(value);
      break;
    case 6:
      var value = new fix_pb.Decimal64;
      reader.readMessage(value,fix_pb.Decimal64.deserializeBinaryFromReader);
      msg.setPrice(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSubmitSuspended(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlacementUser(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnbehalfof(value);
      break;
    case 10:
      var value = new proto.it_grpc.InstrumentOverride;
      reader.readMessage(value,proto.it_grpc.InstrumentOverride.deserializeBinaryFromReader);
      msg.setInstOverride(value);
      break;
    case 11:
      var value = /** @type {!proto.it_grpc.OrderStateEnum} */ (reader.readEnum());
      msg.setOrderStatus(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setUpdInstOnly(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.OrderEntryDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.OrderEntryDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.OrderEntryDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.OrderEntryDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getComments();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubaccount();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSide();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getQuantity();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getPrice();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      fix_pb.Decimal64.serializeBinaryToWriter
    );
  }
  f = message.getSubmitSuspended();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getPlacementUser();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getOnbehalfof();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getInstOverride();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto.it_grpc.InstrumentOverride.serializeBinaryToWriter
    );
  }
  f = message.getOrderStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getUpdInstOnly();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
};


/**
 * optional string ord_id = 1;
 * @return {string}
 */
proto.it_grpc.OrderEntryDetails.prototype.getOrdId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setOrdId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string comments = 2;
 * @return {string}
 */
proto.it_grpc.OrderEntryDetails.prototype.getComments = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setComments = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string subaccount = 3;
 * @return {string}
 */
proto.it_grpc.OrderEntryDetails.prototype.getSubaccount = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setSubaccount = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional SingleGeneralOrderHandling.SideEnum side = 4;
 * @return {!proto.SingleGeneralOrderHandling.SideEnum}
 */
proto.it_grpc.OrderEntryDetails.prototype.getSide = function() {
  return /** @type {!proto.SingleGeneralOrderHandling.SideEnum} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.SingleGeneralOrderHandling.SideEnum} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setSide = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional fix.Decimal64 quantity = 5;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.OrderEntryDetails.prototype.getQuantity = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 5));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
*/
proto.it_grpc.OrderEntryDetails.prototype.setQuantity = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.clearQuantity = function() {
  return this.setQuantity(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.OrderEntryDetails.prototype.hasQuantity = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional fix.Decimal64 price = 6;
 * @return {?proto.fix.Decimal64}
 */
proto.it_grpc.OrderEntryDetails.prototype.getPrice = function() {
  return /** @type{?proto.fix.Decimal64} */ (
    jspb.Message.getWrapperField(this, fix_pb.Decimal64, 6));
};


/**
 * @param {?proto.fix.Decimal64|undefined} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
*/
proto.it_grpc.OrderEntryDetails.prototype.setPrice = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.clearPrice = function() {
  return this.setPrice(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.OrderEntryDetails.prototype.hasPrice = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool submit_suspended = 7;
 * @return {boolean}
 */
proto.it_grpc.OrderEntryDetails.prototype.getSubmitSuspended = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setSubmitSuspended = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string placement_user = 8;
 * @return {string}
 */
proto.it_grpc.OrderEntryDetails.prototype.getPlacementUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setPlacementUser = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string onbehalfof = 9;
 * @return {string}
 */
proto.it_grpc.OrderEntryDetails.prototype.getOnbehalfof = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setOnbehalfof = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional InstrumentOverride inst_override = 10;
 * @return {?proto.it_grpc.InstrumentOverride}
 */
proto.it_grpc.OrderEntryDetails.prototype.getInstOverride = function() {
  return /** @type{?proto.it_grpc.InstrumentOverride} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.InstrumentOverride, 10));
};


/**
 * @param {?proto.it_grpc.InstrumentOverride|undefined} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
*/
proto.it_grpc.OrderEntryDetails.prototype.setInstOverride = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.clearInstOverride = function() {
  return this.setInstOverride(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.OrderEntryDetails.prototype.hasInstOverride = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional OrderStateEnum order_status = 11;
 * @return {!proto.it_grpc.OrderStateEnum}
 */
proto.it_grpc.OrderEntryDetails.prototype.getOrderStatus = function() {
  return /** @type {!proto.it_grpc.OrderStateEnum} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.it_grpc.OrderStateEnum} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setOrderStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional bool upd_inst_only = 12;
 * @return {boolean}
 */
proto.it_grpc.OrderEntryDetails.prototype.getUpdInstOnly = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.it_grpc.OrderEntryDetails} returns this
 */
proto.it_grpc.OrderEntryDetails.prototype.setUpdInstOnly = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.it_grpc.ITrdrOrderEntryMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.it_grpc.ITrdrOrderEntryMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderEntryMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    ordRequestType: jspb.Message.getFieldWithDefault(msg, 1, 0),
    order: (f = msg.getOrder()) && proto.it_grpc.OrderEntryDetails.toObject(includeInstance, f),
    placementUser: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage}
 */
proto.it_grpc.ITrdrOrderEntryMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.it_grpc.ITrdrOrderEntryMessage;
  return proto.it_grpc.ITrdrOrderEntryMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.it_grpc.ITrdrOrderEntryMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage}
 */
proto.it_grpc.ITrdrOrderEntryMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.it_grpc.OrderEntryMessageTypeEnum} */ (reader.readEnum());
      msg.setOrdRequestType(value);
      break;
    case 2:
      var value = new proto.it_grpc.OrderEntryDetails;
      reader.readMessage(value,proto.it_grpc.OrderEntryDetails.deserializeBinaryFromReader);
      msg.setOrder(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlacementUser(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.it_grpc.ITrdrOrderEntryMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.it_grpc.ITrdrOrderEntryMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.it_grpc.ITrdrOrderEntryMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOrdRequestType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.it_grpc.OrderEntryDetails.serializeBinaryToWriter
    );
  }
  f = message.getPlacementUser();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional OrderEntryMessageTypeEnum ord_request_type = 1;
 * @return {!proto.it_grpc.OrderEntryMessageTypeEnum}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.getOrdRequestType = function() {
  return /** @type {!proto.it_grpc.OrderEntryMessageTypeEnum} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.it_grpc.OrderEntryMessageTypeEnum} value
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage} returns this
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.setOrdRequestType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional OrderEntryDetails order = 2;
 * @return {?proto.it_grpc.OrderEntryDetails}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.getOrder = function() {
  return /** @type{?proto.it_grpc.OrderEntryDetails} */ (
    jspb.Message.getWrapperField(this, proto.it_grpc.OrderEntryDetails, 2));
};


/**
 * @param {?proto.it_grpc.OrderEntryDetails|undefined} value
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage} returns this
*/
proto.it_grpc.ITrdrOrderEntryMessage.prototype.setOrder = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage} returns this
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.clearOrder = function() {
  return this.setOrder(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.hasOrder = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string placement_user = 3;
 * @return {string}
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.getPlacementUser = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.it_grpc.ITrdrOrderEntryMessage} returns this
 */
proto.it_grpc.ITrdrOrderEntryMessage.prototype.setPlacementUser = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.it_grpc.ParentOrderTypeEnum = {
  PARENT_ORDER_TYPE_EXCHANGE_ORDER: 0,
  PARENT_ORDER_TYPE_EXCHANGE_ORDER_MASTER: 1,
  PARENT_ORDER_TYPE_MARKET_ORDER: 2,
  PARENT_ORDER_TYPE_STRATEGY: 3
};

/**
 * @enum {number}
 */
proto.it_grpc.OrderStateEnum = {
  ORDER_STATE_OPEN: 0,
  ORDER_STATE_DONE: 1,
  ORDER_STATE_PARTIAL_FILL: 2,
  ORDER_STATE_ERROR: 3,
  ORDER_STATE_ZOMBIE: 4,
  ORDER_STATE_PAUSED: 5,
  ORDER_STATE_CANCELLED: 6,
  ORDER_STATE_SUSPENDED: 7,
  ORDER_STATE_FILLED: 8,
  ORDER_STATE_PARTIAL: 9
};

/**
 * @enum {number}
 */
proto.it_grpc.OpenOrderStateEnum = {
  OPEN_ORDER_STATE_ACTIVE: 0,
  OPEN_ORDER_STATE_PAUSED: 1,
  OPEN_ORDER_STATE_INACTIVE: 2,
  OPEN_ORDER_STATE_WAITING: 3,
  OPEN_ORDER_STATE_SUSPENDED: 4
};

/**
 * @enum {number}
 */
proto.it_grpc.OvernightOrderStatusEnum = {
  OVERNIGHT_ORDER_STAGED_NEW: 0,
  OVERNIGHT_ORDER_STAGED_ROLLED: 1,
  OVERNIGHT_ORDER_CANCELLED: 2,
  OVERNIGHT_ORDER_RELEASED: 3,
  OVERNIGHT_ORDER_RELEASE_ERROR: 4
};

/**
 * @enum {number}
 */
proto.it_grpc.OrderEntryMessageTypeEnum = {
  NEW_ORD_TYPE: 0,
  MODIFY_ORD_TYPE: 1,
  CANCEL_ORD_TYPE: 2,
  PAUSE_ORD_TYPE: 3,
  RESUME_ORD_TYPE: 4
};

goog.object.extend(exports, proto.it_grpc);
